import React from 'react';
import ImageUploadProcessor from './ImageUploadProcessor';
import './App.css';

function App() {
  return (
    <div className="App">
      <ImageUploadProcessor />
    </div>
  );
}

export default App;